import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/ttlockList",
  component: function component() {
    return import("../../../views/ttlock/ttlockList.vue");
  },
  name: "ttlockList",
  meta: {
    title: "通通锁",
    foot: true
  }
}];